import styled from 'styled-components';
import { lighten } from 'polished';
import { Flex, Box } from 'reflexbox/styled-components';
import Image from 'next/image';

import { colors } from '@/themes';
import Section from '@/components/section';
import TitleBase from '@/components/title';
import SubTitle from '@/components/sub-title';

const Title = styled(TitleBase)`
  color: ${props => props.theme.colors.brand.primary};
  margin-top: 0;
`;

const RightColumn = styled(Box)`
  > div, img {
    border-radius: 1vw;
    box-shadow: ${props => props.theme.shadows.hover};
  }
`;

const Hero = () => {
  return (
    <Section backgroundColor={lighten(.35, colors.brand.primary)}>
      <Flex flexWrap="wrap">
        <Box width={[1, 2/3]} mb="1em" pr="1em">
          <Title>Careers at Bidali</Title>
          <SubTitle>You can change the way world does business.</SubTitle>
        </Box>
        <RightColumn width={[1, 1/3]} pl="1em">
          <Image height={366} src="/images/shop-sign.jpg" width={550} alt="Open Sign" />
        </RightColumn>
      </Flex>
    </Section>
  );
};

export default Hero;
